import WellframeNavbarLogo from 'assets/cobrand/wellframe/WellframeNavbarLogo.svg';
import WellframeLoginLogo from 'assets/cobrand/wellframe/WellframeLoginLogo.svg';
import WellframeAppPreviewImg from 'assets/cobrand/wellframe/WellframeAppPreview.avif';

import HarvardPilgrimNavbarLogo from 'assets/cobrand/harvardPilgrim/HarvardPilgrimNavbarLogo.svg';
import HarvardPilgrimLoginLogo from 'assets/cobrand/harvardPilgrim/HarvardPilgrimLoginLogo.svg';
import HarvardPilgrimAppPreviewImg from 'assets/cobrand/harvardPilgrim/HarvardPilgrimAppPreview.avif';

import BcbsKansasCityNavbarLogo from 'assets/cobrand/bcbsKansasCity/BcbsKansasCityNavbarLogo.svg';
import BcbsKansasCityLoginLogo from 'assets/cobrand/bcbsKansasCity/BcbsKansasCityLoginLogo.svg';
import BcbsKansasCityAppPreviewImg from 'assets/cobrand/bcbsKansasCity/BcbsKansasCityAppPreview.avif';

import BcbsSouthCarolinaNavbarLogo from 'assets/cobrand/bcbsSouthCarolina/BcbsSouthCarolinaNavbarLogo.svg';
import BcbsSouthCarolinaLoginLogo from 'assets/cobrand/bcbsSouthCarolina/BcbsSouthCarolinaLoginLogo.svg';
import BcbsSouthCarolinaAppPreviewImg from 'assets/cobrand/bcbsSouthCarolina/BcbsSouthCarolinaAppPreview.avif';

import BcbsTennesseeNavbarLogo from 'assets/cobrand/bcbsTennessee/BcbsTennesseeNavbarLogo.svg';
import BcbsTennesseeLoginLogo from 'assets/cobrand/bcbsTennessee/BcbsTennesseeLoginLogo.svg';
import BcbsTennesseeAppPreviewImg from 'assets/cobrand/bcbsTennessee/BcbsTennesseeAppPreview.avif';

import HscsnNavbarLogo from 'assets/cobrand/hscsn/HscsnNavbarLogo.svg';
import HscsnLoginLogo from 'assets/cobrand/hscsn/HscsnLoginLogo.svg';
import HscsnAppPreviewImg from 'assets/cobrand/hscsn/HscsnAppPreview.avif';

import CareFirstNavbarLogo from 'assets/cobrand/careFirst/CareFirstNavbarLogo.svg';
import CareFirstLoginLogo from 'assets/cobrand/careFirst/CareFirstLoginLogo.svg';
import CareFirstAppPreviewImg from 'assets/cobrand/careFirst/CareFirstAppPreview.avif';

import CareElevateNavbarLogo from 'assets/cobrand/careelevate/CareElevateNavbarLogo.svg';
import CareElevateLoginLogo from 'assets/cobrand/careelevate/CareElevateLoginLogo.svg';
import CareElevateAppPreviewImg from 'assets/cobrand/careelevate/CareElevateAppPreview.avif';

import { CobrandIdentifier } from '../types';

export const cobrandImages: Record<
  CobrandIdentifier,
  { logo: string; loginLogo: string; appPreviewImg: string }
> = {
  [CobrandIdentifier.WELLFRAME]: {
    logo: WellframeNavbarLogo,
    loginLogo: WellframeLoginLogo,
    appPreviewImg: WellframeAppPreviewImg,
  },
  [CobrandIdentifier.HARVARD_PILGRIM]: {
    logo: HarvardPilgrimNavbarLogo,
    loginLogo: HarvardPilgrimLoginLogo,
    appPreviewImg: HarvardPilgrimAppPreviewImg,
  },
  [CobrandIdentifier.BCBS_KANSAS_CITY]: {
    logo: BcbsKansasCityNavbarLogo,
    loginLogo: BcbsKansasCityLoginLogo,
    appPreviewImg: BcbsKansasCityAppPreviewImg,
  },
  [CobrandIdentifier.BCBS_SOUTH_CAROLINA]: {
    logo: BcbsSouthCarolinaNavbarLogo,
    loginLogo: BcbsSouthCarolinaLoginLogo,
    appPreviewImg: BcbsSouthCarolinaAppPreviewImg,
  },
  [CobrandIdentifier.BCBS_TENNESSEE]: {
    logo: BcbsTennesseeNavbarLogo,
    loginLogo: BcbsTennesseeLoginLogo,
    appPreviewImg: BcbsTennesseeAppPreviewImg,
  },
  [CobrandIdentifier.HSCSN]: {
    logo: HscsnNavbarLogo,
    loginLogo: HscsnLoginLogo,
    appPreviewImg: HscsnAppPreviewImg,
  },
  [CobrandIdentifier.CARE_FIRST]: {
    logo: CareFirstNavbarLogo,
    loginLogo: CareFirstLoginLogo,
    appPreviewImg: CareFirstAppPreviewImg,
  },
  [CobrandIdentifier.CARE_ELEVATE]: {
    logo: CareElevateNavbarLogo,
    loginLogo: CareElevateLoginLogo,
    appPreviewImg: CareElevateAppPreviewImg,
  },
};
